import React, { useState } from "react";
import { Box, Button, Container, Image, Link, Text } from "@chakra-ui/react";
import logoMain from "common/assets/img/logoMain.png";
import { landingPageConstants } from "common/landingPageConstants";
import { useLocation } from "react-router-dom";

const Header = ({ handleNavigate }) => {
  const [menuVisible, setMenuVisible] = useState(false);

  const toggleMenu = () => setMenuVisible(true);
  const closeMenu = () => setMenuVisible(false);
  const location = useLocation();

 const hideAction = location.pathname.includes("/createWorkspace");

  return (
    <Container maxW="container.xl">
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        padding="20px 0"
        className="headerLanding"
      >
          <Box>
            <Image src={logoMain} boxSize="auto" width="79px" alt="logo" />
          </Box>
          <Box
            display="flex"
            gap="28px"
            className={`menuItems ${menuVisible ? "showHeader" : ""}`}
          >
            <Link className="navLinks" href="">
              {landingPageConstants.Home}
            </Link>
            <Link className="navLinks" href="#features">
              {landingPageConstants.feature}
            </Link>
            <Link className="navLinks" href="#whyUs">
              {landingPageConstants.whyUs}
            </Link>
            <Link className="navLinks" href="#pricing">
              {landingPageConstants.plans}
            </Link>
            <Link className="navLinks" href="#faq">
              {landingPageConstants.faq}
            </Link>
            <Link className="navLinks" href="#contact">
              {landingPageConstants.contact}
            </Link>
            <Box className="closeMenu" onClick={closeMenu} cursor="pointer">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="36"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#303030"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-circle-x-icon"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="m15 9-6 6" />
                <path d="m9 9 6 6" />
              </svg>
            </Box>
          </Box>
     {!hideAction && (
        <Box
          display="flex"
          gap={{base: "8px", md: "16px"}}
          alignItems="center"
          fontWeight="500"
          fontSize="14px"
        >
          <Button onClick={handleNavigate} variant={"outlined"} className="customButton outlined landingButtons">{landingPageConstants.login}</Button>
          <Link href="/#/createWorkspace">
            <Button
            colorScheme="brand"
            fontWeight="500"
            height="40px"
            fontSize="14px"
            borderRadius="8px !important"
            className="landingButtons"
          >
            {landingPageConstants.getStarted}
          </Button>
          </Link>
          <Box className="toggleBtn" onClick={toggleMenu} cursor="pointer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#303030"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-square-menu-icon"
            >
              <rect width="18" height="18" x="3" y="3" rx="2" />
              <path d="M7 8h10" />
              <path d="M7 12h10" />
              <path d="M7 16h10" />
            </svg>
          </Box>
        </Box>
     )}
       
      </Box>
    </Container>
  );
};

export default Header;
